import {
  RawConceptData,
  RawSubjectToConceptData,
} from "../../Concepts.interface";

export const MIDDLE_SCHOOL_ELA_ID = "cmcxoxi7x00063690a44uiu02";

// Returns the first 5 topics from the Middle School Language Arts node of the
// ELA taxonomy tree (one level below the subject groupings) to display as
// quick filters in the Topics filter section.
export const getTopFiveTags = (rawTaxonomyData: RawSubjectToConceptData) => {
  const elaItems = rawTaxonomyData?.ela?.items;
  if (!elaItems) return [];

  const middleSchoolNode = elaItems[MIDDLE_SCHOOL_ELA_ID] as
    | RawConceptData
    | undefined;
  if (!middleSchoolNode) return [];

  return middleSchoolNode.children.slice(0, 5).flatMap((id: string) => {
    const node = elaItems[id] as RawConceptData | undefined;
    if (!node) return [];
    return [
      {
        id,
        name: node.data.name,
        description: node.data.description || "",
        parentId: node.data.parent,
        isFolder: node.isFolder,
        children: [],
      },
    ];
  });
};
